// VIPSlider: Slider for VIPs on public home page
import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

const vips = [
  { name: 'Jane Doe', role: 'VIP Guest', img: '/assets/vip1.jpg' },
  { name: 'John Smith', role: 'VIP Speaker', img: '/assets/vip2.jpg' },
  // More VIPs can be added from admin/CMS
  { name: 'Add more VIPs via CMS', role: 'VIP', img: '/assets/vip-placeholder.jpg' },
];

function VIPSlider() {
  return (
    <Box sx={{ display: 'flex', gap: 3, my: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
      {vips.map((vip) => (
        <Box key={vip.name} sx={{ textAlign: 'center', width: { xs: 120, sm: 160 }, flex: '0 0 auto' }}>
          <Avatar src={vip.img} sx={{ width: { xs: 56, sm: 72, md: 80 }, height: { xs: 56, sm: 72, md: 80 }, mx: 'auto', mb: 1 }} />
          <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>{vip.name}</Typography>
          <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' }, color: 'text.secondary' }}>{vip.role}</Typography>
        </Box>
      ))}
    </Box>
  );
}

export default VIPSlider;
